import { FastlyImage } from '@components/common/image'
import Card from '@components/teacher-lp/card'
import { UNMATCHED_EARNING_CARD_DATA } from '@lib/data/teacher-lp'

const IMAGE_PATH = '/images/teacher-lp/unmatched-earnings/'

type Props = {
  handleBecomeTeacher: () => void
  countryCode: string
}

const UnmatchedEarnings = ({ countryCode, handleBecomeTeacher }: Props) => (
  <div
    className="container mx-auto relative mt-20 md:mt-24"
    id="unmatched-earning"
  >
    <Card
      data={
        UNMATCHED_EARNING_CARD_DATA[`${countryCode === 'IN' ? 'IN' : 'US'}`]
      }
      heading="Unmatched earnings and growth"
      imagePath={IMAGE_PATH}
      iconAlignment="items-baseline"
      titleAlignment="text-left"
      descriptionAlignment="text-left"
    />

    <div className="md:flex md:justify-center py-8 md:pt-12 px-4 md:px-0">
      <button
        onClick={handleBecomeTeacher}
        className="btn btn-orange py-3 md:text-xl text-2xl text-center md:text-left font-600 w-full md:w-auto"
      >
        Become a teacher
      </button>
    </div>

    <div className="mx-4 my-10 md:my-20 md:mx-10">
      <div className="hidden md:block">
        <FastlyImage
          src={`${IMAGE_PATH}happy-to-show-laptop.png`}
          className="hidden md:block"
          alt="happy-to-show-laptop image"
          height="500"
          width="1800"
        />
      </div>
      <div className="md:hidden">
        <FastlyImage
          src={`${IMAGE_PATH}happy-to-show-laptop-mobile.png`}
          alt="happy-to-show-laptop image"
          height="200"
          width="350"
        />
      </div>
    </div>
  </div>
)

export default UnmatchedEarnings
